const unitSizeTypes = [
    'px',
    'percentage',
    'fr',
    'vh',
    'vw',
    'rem',
    'em',
    'spx',
    'cqw',
    'cqh',
];
const isUnitSize = (size) => {
    return Boolean(size && unitSizeTypes.includes(size.type));
};
const isHorizontallyDocked = (compLayout, singleLayoutData) => {
    const itemLayout = singleLayoutData?.itemLayout;
    if (!itemLayout) {
        return !!(compLayout.docked?.right && compLayout.docked?.left);
    }
    if (itemLayout.type === 'MeshItemLayout') {
        // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
        // @ts-ignore this code will be replaced soon, TB API was changed
        return !!(itemLayout.left && itemLayout.right);
    }
    if (itemLayout.type === 'FixedItemLayout') {
        return !!(itemLayout.margins?.left && itemLayout.margins.right);
    }
    return false;
};
const isDocked = (compLayout, singleLayoutData) => {
    const itemLayout = singleLayoutData?.itemLayout;
    if (!itemLayout) {
        return !!(compLayout.docked?.right ??
            compLayout.docked?.left ??
            compLayout.docked?.top ??
            compLayout.docked?.bottom);
    }
    if (itemLayout.type === 'MeshItemLayout') {
        // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
        // @ts-ignore
        return !!(itemLayout.left && itemLayout.right);
    }
    if (itemLayout.type === 'FixedItemLayout') {
        return !!(itemLayout.margins?.right ??
            itemLayout.margins?.left ??
            itemLayout.margins?.top ??
            itemLayout.margins?.bottom);
    }
    return false;
};
const isFixedPositionLegacy = (compLayout, singleLayoutData) => {
    return ((singleLayoutData?.itemLayout &&
        singleLayoutData?.itemLayout?.type === 'FixedItemLayout') ??
        compLayout.fixedPosition);
};
const getContainerHeightCSS = (singleLayoutData) => {
    if (singleLayoutData?.componentLayout?.height?.type === 'auto' &&
        singleLayoutData?.componentLayout?.minHeight?.cssValue) {
        return singleLayoutData.componentLayout.minHeight.cssValue;
    }
    return;
};
const getHeightCSS = (compLayout, singleLayoutData) => {
    return (getContainerHeightCSS(singleLayoutData) ??
        singleLayoutData?.componentLayout?.height?.cssValue ??
        `${compLayout.height}px`);
};
const getHeightPixelValue = (compLayout, singleLayoutData) => {
    if (singleLayoutData?.componentLayout?.height?.type === 'auto' &&
        singleLayoutData?.componentLayout?.minHeight?.value !==
            undefined) {
        return singleLayoutData?.componentLayout?.minHeight?.value;
    }
    return (singleLayoutData?.componentLayout?.height?.value ??
        compLayout.height);
};
const getWidthCSS = (compLayout, singleLayoutData) => {
    return (singleLayoutData?.componentLayout?.width?.cssValue ??
        `${compLayout.width}px`);
};
const getWidthPixelValue = (compLayout, singleLayoutData) => {
    return (singleLayoutData?.componentLayout?.width?.value ??
        compLayout.width);
};
const getTopCSS = (compLayout, singleLayoutData) => {
    return (singleLayoutData?.itemLayout?.margins?.top?.cssValue ?? `${compLayout.y}px`);
};
const getLeftCSS = (compLayout, singleLayoutData) => {
    if (singleLayoutData?.itemLayout?.type === 'MeshItemLayout' &&
        // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
        // @ts-ignore this code will be replaced soon, TB API was changed
        singleLayoutData.itemLayout.left?.cssValue !== undefined) {
        // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
        // @ts-ignore this code will be replaced soon, TB API was changed
        return singleLayoutData.itemLayout.left.cssValue;
    }
    if (singleLayoutData?.itemLayout?.type === 'FixedItemLayout' &&
        isUnitSize(singleLayoutData.itemLayout.margins?.left)) {
        return singleLayoutData.itemLayout.margins.left.cssValue;
    }
    if (isHorizontallyDocked(compLayout, singleLayoutData)) {
        return `${compLayout.docked.left.px}px`;
    }
    return `${compLayout.x}px`;
};
const getRotationInDegrees = (compLayout, singleLayoutData) => {
    return (
    // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
    // @ts-ignore this code will be replaced soon, TB API was changed
    singleLayoutData?.componentLayout?.rotationInDegrees ??
        compLayout.rotationInDegrees);
};
export { isHorizontallyDocked, isDocked, isFixedPositionLegacy, getHeightCSS, getWidthCSS, getTopCSS, getWidthPixelValue, getHeightPixelValue, getRotationInDegrees, getLeftCSS, };
//# sourceMappingURL=compLayoutConverters.js.map